import { Fragment, useContext, useEffect, useRef, useState } from "react"
import { useReactToPrint } from "react-to-print"
import ManifestoPrintBody from "overrides/theme/entel/base/components/Custom/ManifestoPrintButton/ManifestoPrintBody"
import { formatDate } from "helpers/FormatDateHelper"
import { useTranslation } from "react-i18next"
import { GlobalContext } from "context/context"

const ManifestoPrintButton = ({ data: _data }: any) => {
  const { t } = useTranslation()
  const componentRef = useRef<HTMLDivElement>(null)
  const [show_tag, set_show_tag] = useState<boolean>(false)
  const { state_machine_states } = useContext(GlobalContext)

  useEffect(() => {
    const currentStatusTag = _data?._sg?._omnixStateMachine?.currentState?.state?.id?.toUpperCase()
    const PICKING_COMPLETED_PENDING_PACKAGE_INDEX = state_machine_states?.state
      ?.map((st: any) => st?.label)
      .indexOf("PICKING_COMPLETED_PENDING_PACKAGE")
    const CURRENT_STATUS_INDEX = state_machine_states?.state?.map((st: any) => st?.label).indexOf(currentStatusTag)
    if (CURRENT_STATUS_INDEX >= PICKING_COMPLETED_PENDING_PACKAGE_INDEX) {
      set_show_tag(true)
    }
    if (currentStatusTag === "DELIVER_TO_COURIER" || currentStatusTag === "DELIVERED_TO_COURIER") {
      set_show_tag(true)
    }
    // eslint-disable-next-line
  }, [_data?._sg])

  const get_courier_name = () => {
    const courierName =
      _data?._order?.logisticPlan?.sources?.length &&
      _data?._order?.logisticPlan?.sources[0]?.route?.length &&
      _data?._order?.logisticPlan?.sources[0]?.route[0].courier?.name

    const enviame_courierName = _data?._sg?.courier?.enviame?.data?.carrier

    return courierName?.toUpperCase() === "ENVIAME" ? enviame_courierName : courierName
  }

  const manifestoData = {
    courierName: get_courier_name(),
    numeroManifesto: `${_data?._sg?.salesChannelId}${formatDate(new Date(), "ddMMyyyy")}`,
    cliente: `${_data?._sg?.source?.id} - ${_data?._sg?.source?.name}`,
    fechaCierre: formatDate(new Date(), "dd/MM/yyyy"),
    totalEnvios: 1,
    totalBultos: 1,
    paginas: "1/1",
    destinatarios: [
      {
        nro: 1,
        destinatario: _data?._sg?.shippingAddress?.contact?.name,
        comuna: _data?._sg?.shippingAddress?.commune,
        referencia: _data?._sg?.salesChannelId,
        seguimiento: _data?._sg?.salesChannelId,
        bultos: "1/1",
      },
    ],
    clienteInfo: {
      nombreRutFirma: "NOMBRE - RUT - FIRMA",
    },
    transporteInfo: {
      fechaHoraRetiro: "",
      nombreRut: "",
      cantidadPalletsRetirados: "",
      firma: "",
    },
    admisionInfo: {
      nombreRutFirma: "NOMBRE - RUT - FIRMA",
    },
  }

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `manifesto_${manifestoData?.numeroManifesto}_${Date.now()}`,
  })

  if (!show_tag) return null
  return (
    <Fragment>
      <div style={{ display: "none" }}>
        <ManifestoPrintBody ref={componentRef} data={manifestoData} />
      </div>
      <div>
        <p>{t("Manifiesto Omnix")}:</p>
        <div>
          <p onClick={handlePrint}>
            <span>
              <strong className="order__main__detail__folio__url">Manifesto Omnix</strong>
            </span>
          </p>
        </div>
      </div>
    </Fragment>
  )
}

export default ManifestoPrintButton
